// MT — scripts propios (Alivia). Todo vanilla, sin librerías externas.
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initPackProducto();
  initFaq();
  initComparador();
});

// Selector de pack (1 o 2 unidades) en la página de producto
function initPackProducto() {
  var opciones = document.querySelectorAll('[data-mt-pack-opcion]');
  if (!opciones.length) return;
  var cantidadInput = document.querySelector('[data-mt-cantidad]');
  opciones.forEach(function (opcion) {
    var radio = opcion.querySelector('input[type="radio"]');
    opcion.addEventListener('click', function () {
      radio.checked = true;
      opciones.forEach(function (o) {
        o.classList.remove('mt-pack__opcion--activa');
        o.style.borderColor = 'var(--mt-color-borde)';
        o.style.borderWidth = '1px';
      });
      opcion.classList.add('mt-pack__opcion--activa');
      opcion.style.borderColor = 'var(--mt-color-acento)';
      opcion.style.borderWidth = '2px';
      if (cantidadInput) cantidadInput.value = radio.value;
    });
  });
}

// Revela elementos .mt-reveal cuando entran en pantalla
function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

// Cuenta hacia arriba números con data-mt-contador="valor-final"
function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var anim = function (el) {
    var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
    var decimales = (el.getAttribute('data-mt-contador').split('.')[1] || '').length;
    var dur = 1400;
    var t0 = null;
    function paso(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var ease = 1 - Math.pow(1 - p, 3);
      el.textContent = (fin * ease).toFixed(decimales);
      if (p < 1) requestAnimationFrame(paso);
      else el.textContent = fin.toFixed(decimales);
    }
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) { els.forEach(anim); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { anim(entry.target); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}

// Galería de la página de producto: imagen principal + miniaturas + flechas + autoplay
function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var minis = Array.prototype.slice.call(wrap.querySelectorAll('[data-mt-galeria-mini]'));
  if (!principal || !minis.length) return;
  var img = principal.querySelector('img');
  var indice = minis.findIndex(function (m) { return m.classList.contains('mt-mini--activa'); });
  if (indice < 0) indice = 0;

  function irA(nuevoIndice) {
    if (!minis.length) return;
    indice = (nuevoIndice + minis.length) % minis.length;
    var mini = minis[indice];
    var src = mini.getAttribute('data-full');
    var alt = mini.getAttribute('data-alt') || '';
    if (img) { img.src = src; img.alt = alt; }
    minis.forEach(function (m) { m.classList.remove('mt-mini--activa'); m.style.borderColor = 'transparent'; });
    mini.classList.add('mt-mini--activa');
    mini.style.borderColor = 'var(--mt-color-acento)';
  }

  minis.forEach(function (mini, i) {
    mini.addEventListener('click', function () { irA(i); reiniciarAutoplay(); });
  });

  var flechaPrev = principal.querySelector('[data-mt-galeria-flecha="prev"]');
  var flechaNext = principal.querySelector('[data-mt-galeria-flecha="next"]');
  if (flechaPrev) flechaPrev.addEventListener('click', function () { irA(indice - 1); reiniciarAutoplay(); });
  if (flechaNext) flechaNext.addEventListener('click', function () { irA(indice + 1); reiniciarAutoplay(); });

  // Autoplay opcional
  var autoplayActivo = wrap.getAttribute('data-autoplay') === 'true';
  var autoplayMs = parseInt(wrap.getAttribute('data-autoplay-ms'), 10) || 4000;
  var temporizador = null;
  var reduccion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciarAutoplay() {
    if (!autoplayActivo || reduccion || minis.length < 2) return;
    detenerAutoplay();
    temporizador = setInterval(function () { irA(indice + 1); }, autoplayMs);
  }
  function detenerAutoplay() {
    if (temporizador) { clearInterval(temporizador); temporizador = null; }
  }
  function reiniciarAutoplay() { detenerAutoplay(); iniciarAutoplay(); }

  wrap.addEventListener('mouseenter', detenerAutoplay);
  wrap.addEventListener('mouseleave', iniciarAutoplay);
  wrap.addEventListener('touchstart', detenerAutoplay, { passive: true });

  iniciarAutoplay();
}

// Selector de variantes: actualiza precio, id oculto y estado agotado
function initVariantesProducto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-mt-opcion]');
  var inputId = form.querySelector('input[name="id"]');
  var btn = form.querySelector('[data-mt-boton-comprar]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-compare]');

  function moneda(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function actualizarImagenGaleria(encontrada) {
    if (!encontrada.image_full) return;
    var principal = document.querySelector('[data-mt-galeria-principal] img');
    if (principal) {
      principal.src = encontrada.image_full;
      principal.removeAttribute('srcset');
      if (encontrada.image_alt) principal.alt = encontrada.image_alt;
    }
    var minis = document.querySelectorAll('[data-mt-galeria-mini]');
    if (!minis.length || !encontrada.media_id) return;
    var coincide = false;
    minis.forEach(function (mini) {
      var esEsta = mini.getAttribute('data-media-id') === String(encontrada.media_id);
      mini.classList.toggle('mt-mini--activa', esEsta);
      mini.style.borderColor = esEsta ? 'var(--mt-color-acento)' : 'transparent';
      if (esEsta) coincide = true;
    });
  }

  function actualizar(cambiarImagen) {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var encontrada = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!encontrada) return;
    if (inputId) inputId.value = encontrada.id;
    if (precioEl) precioEl.textContent = moneda(encontrada.price);
    if (precioCompareEl) {
      if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
        precioCompareEl.textContent = moneda(encontrada.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (btn) {
      if (encontrada.available) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-texto-disponible') || btn.textContent;
      } else {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
    if (cambiarImagen) actualizarImagenGaleria(encontrada);
  }

  selects.forEach(function (s) { s.addEventListener('change', function () { actualizar(true); }); });
  actualizar(false);
}

// FAQ desplegable accesible
function initFaq() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  items.forEach(function (item) {
    var btn = item.querySelector('[data-mt-faq-pregunta]');
    var panel = item.querySelector('[data-mt-faq-respuesta]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var abierta = item.classList.contains('mt-faq-item--abierta');
      item.classList.toggle('mt-faq-item--abierta', !abierta);
      btn.setAttribute('aria-expanded', String(!abierta));
      panel.style.maxHeight = !abierta ? panel.scrollHeight + 'px' : null;
    });
  });
}

// Comparador antes/después con deslizador
function initComparador() {
  var wraps = document.querySelectorAll('[data-mt-comparador]');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('[data-mt-comparador-handle]');
    var despues = wrap.querySelector('[data-mt-comparador-despues]');
    if (!handle || !despues) return;
    var activo = false;

    function mover(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      despues.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    handle.addEventListener('pointerdown', function (e) { activo = true; handle.setPointerCapture(e.pointerId); });
    window.addEventListener('pointerup', function () { activo = false; });
    wrap.addEventListener('pointermove', function (e) { if (activo) mover(e.clientX); });
    wrap.addEventListener('click', function (e) { mover(e.clientX); });
  });
}
